/**
 * Creates a UK date object with the specified year, month, day, hour, minute, and second values.
 * If any of the parameters are undefined, the corresponding value will be set to the current date and time.
 * @param year - The year value.
 * @param month - The month value (0-11).
 * @param day - The day value (1-31).
 * @param hour - The hour value (0-23).
 * @param minute - The minute value (0-59).
 * @param second - The second value (0-59).
 * @returns A Date object representing the specified date and time.
 */
export function ukDate(
    year: number | undefined,
    month: number | undefined,
    day: number | undefined,
    hour: number | undefined,
    minute: number | undefined,
    second: number | undefined
): Date {
    const date = new Date();
    if (year !== undefined) {
        date.setUTCFullYear(year);
    }
    // we can't set month without day, not every month has the same number of days
    if (month !== undefined) {
        date.setUTCMonth(month, day);
    } else if (day !== undefined) {
        date.setUTCDate(day);
    }
    if (hour !== undefined) {
        date.setUTCHours(isBST(date) ? hour - 1 : hour);
    }
    if (minute !== undefined) {
        date.setUTCMinutes(minute);
    }
    if (second !== undefined) {
        date.setUTCSeconds(second);
    }
    return date;
}

export function ukDateToGMT(date: Date) {
    if (isBST(date)) {
        date.setHours(date.getHours() - 1);
    }
}
export function GMTDateToUK(date: Date) {
    if (isBST(date)) {
        date.setHours(date.getHours() + 1);
    }
}

export function isBST(d: Date) {
    const starts = lastSunday(2, d.getFullYear());
    starts.setHours(1);
    const ends = lastSunday(9, d.getFullYear());
    starts.setHours(1);
    return d.getTime() >= starts.getTime() && d.getTime() < ends.getTime();
}

function lastSunday(month: number, year: number) {
    const d = new Date();
    const lastDayOfMonth = new Date(Date.UTC(year || d.getFullYear(), month + 1, 0));
    const day = lastDayOfMonth.getDay();
    return new Date(Date.UTC(lastDayOfMonth.getFullYear(), lastDayOfMonth.getMonth(), lastDayOfMonth.getDate() - day));
}
